"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter, CreditCard, ShieldCheck, Banknote, Lock } from "lucide-react";
const categories = ["Barcelona", "Girona", "Tarragona", "Lleida (a consultar)"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="231360" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="#" className="text-sm text-foreground/80 hover:text-foreground transition-colors">
            Qui Som
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-sm text-foreground/80 hover:text-foreground transition-colors">
            Sol·licitar pressupost
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-sm text-foreground/80 hover:text-foreground transition-colors">
            Versió en Castellà
          </Link>
        </li>
        <li data-index={3}>
          <Link to="#" className="text-sm text-foreground/80 hover:text-foreground transition-colors">
            English Version
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-foreground/80 hover:text-foreground transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function ReliabilityFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="peu-de-pàgina" className="pt-16 pb-8 border-t border-border/15 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col gap-6 items-center md:items-start text-center md:text-left">
            <Link to="/" className="inline-block w-fit">
              <div className="h-7 w-auto"></div>
            </Link>
            <p className="text-sm text-foreground leading-relaxed w-full max-w-full md:max-w-xs">
              Salvat Serveis Rurals: Serveis rurals i manteniment professional de finques, terrenys i camins amb compromís i respecte pel medi natural.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            
            <ul className="flex flex-col gap-3">
              {categories.map((category, i) => <li key={i} data-index={i} className="flex items-center gap-2">
                  <ShieldCheck className="size-3 text-foreground/60" />
                  <Link to="#" className="text-sm text-foreground/80 hover:text-foreground transition-colors">
                    {category}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            
            <MenuProvider menu_id="21">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6 w-full max-w-full">
            
            <div className="flex flex-col gap-2 w-full">
              <p className="text-sm text-foreground/80 break-all">
                 +34 627 334 205
              </p>
              <p className="text-sm text-foreground/80 break-all">
                 info@salvatserveisrurals.com
              </p>
            </div>
            <div className="flex items-center gap-4">
              <Link to="#" className="text-foreground/60 hover:text-foreground transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="#" className="text-foreground/60 hover:text-foreground transition-colors" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="#" className="text-foreground/60 hover:text-foreground transition-colors" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
            </div>
          </div>

        </div>

        <Separator className="mb-8 bg-foreground/15" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[12px] text-foreground/70 font-default">
            &copy; {currentYear} Salvat Serveis Rurals. Tots els drets reservats.
          </p>
          
          
        </div>
      </div>
    </section>;
}